import makeRequest from "./makeRequest";
import getRuntimeConstants from "../runtimeConstants";
import { getAuthorisationHeader, getCustomerId } from "../utils/identity";
import { PATCH } from "../constants";

const MARKETING_GLOBAL_ID = "marketingGlobal";

export const MARKETING_CONSENT_STATUS = {
  OPTED_IN: "optedIn",
  OPTED_OUT: "optedOut",
};

export default async function getCustomerPreferences({ services = [] } = {}) {
  const {
    webContext: { browseCountry, browseLanguage },
    customerPreferencesApiEndpoint,
    customerPreferencesApiTimeout,
  } = getRuntimeConstants();

  const customerId = await getCustomerId();
  const url = `${customerPreferencesApiEndpoint}/${customerId}`;

  const authorization = await getAuthorisationHeader();

  const params = {
    country: browseCountry,
    expand: "content",
    lang: browseLanguage,
  };

  if (services.length) {
    params.services = services.join(",");
  }

  return makeRequest({
    url,
    params,
    timeout: customerPreferencesApiTimeout,
    requestType: "CUSTOMER_PREFERENCES_API",
    apiName: "CustomerPreference",
    caller: "CustomerPreferences",
    headers: {
      authorization,
    },
    handleErrorReturnValue: () => null,
  });
}

export async function getMarketingConsentStatus() {
  const preferences = await getCustomerPreferences({
    services: [MARKETING_GLOBAL_ID],
  });
  const marketingService = preferences?.services?.find(
    (service) => service.serviceId === MARKETING_GLOBAL_ID,
  );
  const marketingPreference = marketingService?.preferences?.find(
    (pref) => pref.preferenceId === MARKETING_GLOBAL_ID,
  );

  return marketingPreference?.consentStatus;
}

// TODO: Remove JSDoc type annotations below once this file is migrated to TypeScript (.ts).
// They exist only to avoid TypeScript syntax errors in the .tsx files that consume this function.
// Migration is blocked by the dependency on `makeRequest.js` which is not yet TypeScript.
/**
 * @param {object} [options]
 * @param {string} [options.sourceReason]
 * @param {string[]} [options.customerChannels]
 */
export async function setMarketingConsentStatus({
  sourceReason,
  customerChannels = ["emailAddress", "push"],
} = {}) {
  const { customerPreferencesApiEndpoint, customerPreferencesApiTimeout } =
    getRuntimeConstants();

  const customerId = await getCustomerId();
  const url = `${customerPreferencesApiEndpoint}/${customerId}`;
  const authorization = await getAuthorisationHeader();

  return makeRequest({
    url,
    timeout: customerPreferencesApiTimeout,
    requestType: "CUSTOMER_PREFERENCES_API",
    apiName: "CustomerPreference",
    caller: "CustomerPreferences",
    method: PATCH,
    headers: {
      authorization,
      "Content-Type": "application/json",
    },
    body: {
      sourceReason,
      services: {
        [MARKETING_GLOBAL_ID]: [
          {
            preferenceId: MARKETING_GLOBAL_ID,
            customerChannels,
          },
        ],
      },
    },
    handleErrorReturnValue: (error) => {
      throw error;
    },
  });
}
